import { render } from "./cascader-switch.vue?vue&type=template&id=53bc2430&scoped=true"
import script from "./cascader-switch.vue?vue&type=script&lang=js"
export * from "./cascader-switch.vue?vue&type=script&lang=js"

import "./cascader-switch.vue?vue&type=style&index=0&id=53bc2430&scoped=true&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53bc2430"]])

export default __exports__